import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {  Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import * as util from "../utils/util";

function CircularProgressWithLabel(props :any) {

  // goal 이 0 이거나 값이 비어 있으면 value/goal 이 NaN(0/0) 또는 Infinity 가 되어
  // Gauge 의 SVG path 가 "M0,-40LNaN,NaNZ" 로 깨진다. API 응답 전 초기 렌더가 대표적.
  const goal = Number(props.progress.goal);
  const value = Number(props.progress.value);
  const gaugeValue = Number.isFinite(goal) && goal > 0 && Number.isFinite(value)
    ? (value / goal) * 100
    : 0;

  const labelSource = props.progress.type === 'month' ? props.progress.value : props.progress.goal;
  const labelNumber = Number(labelSource);

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}  className='CircleChart'   >
      {/* <CircularProgress variant="determinate" {...props} className='CircleChart' sx={{color:"#EF8322"}}  /> */}
      <Gauge width={100} height={100} value={gaugeValue} className='CircleChart'
       cornerRadius="50%"
       sx={ ({
         [`& .${gaugeClasses.valueText}`]: {
           fontSize: 20,
           display:'none'
         },
         [`& .${gaugeClasses.valueArc}`]: {
           fill: '#EF8322',
         },
         [`& .${gaugeClasses.referenceArc}`]: {
           fill: '#eaeaea'
         },
       })}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          className='circleText'
          color="#aaa"
          fontSize={18}
          fontWeight={700}
        >{`${util.formatComma(Math.round(Number.isFinite(labelNumber) ? labelNumber : 0))}`}
          {props.progress.type === 'month' ? '%' : ''}
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;